const NotificaionsMainView = () => import('@/views/superadmin/notifications/NotificationsMianView')
const NotificaionsView = () => import('@/views/superadmin/notifications/NotificationsView')
const TemplatesMassView = () => import('@/views/superadmin/notifications/TemplatesMassView')
const TemplatesView = () => import('@/views/superadmin/notifications/templates/TemplatesView')
const SendNotificationView = () => import('@/views/superadmin/notifications/SendNotificationView')

export default {
  path: 'notifications',
  redirect: { name: 'NotificationsSuperAdmin' },
  name: 'NotificationsMainSuperAdmin',
  component: NotificaionsMainView,
  meta: { label: 'Уведомления' },
  children: [
    {
      path: 'read',
      name: 'NotificationsSuperAdmin',
      component: NotificaionsView,
      meta: { label: 'Чтение уведомлений' }
    },
    {
      path: 'send',
      name: 'SendNotificationSuperAdmin',
      component: SendNotificationView,
      meta: { label: 'Отправка уведомления' }
    },
    {
      path: 'templates',
      name: 'TemplatesSuperAdmin',
      component: TemplatesView,
      meta: { label: 'Шаблоны' }
    },
    {
      path: 'templates-mass',
      name: 'TemplatesMassSuperAdmin',
      component: TemplatesMassView,
      meta: { label: 'Шаблоны массовой рассылки' }
    }
  ]
}